module.exports = __webpack_public_path__ + "fcb70649d060962db0e560440c78c631.png";